import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Left = styled.div`
  display: flex;
  width: 50%;
  flex-direction: column;
  align-items: flex-end;
  position: relative;

  @media (max-width: 1200px) {
    flex: 0 0 40%;
  }
`;

export const Right = styled.div`
  position: relative;
  display: flex;
  width: 50%;
  flex-direction: column;
  align-items: flex-start;
`;

interface IDescriptionProps {
  isLeft?: boolean;
}

export const Description = styled.div<IDescriptionProps>`
  height: 8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1200px) {
    justify-content: start;
  }

  & div span {
    display: block;
    margin: 0 1.6rem;
    @media (max-width: 1200px) {
      margin: 0 0 0 1.6rem;
    }
  }

  .title {
    font-size: 1.6rem;
    line-height: 2rem;
    font-weight: 300;
    font-family: "Galano";
    color: #565656;
    text-transform: uppercase;
    letter-spacing: 0.352rem;
    text-align: ${(props) => (props.isLeft ? "end" : "unset")};
    @media (max-width: 1200px) {
      font-size: 1.4rem;
    }
  }

  .description {
    font-size: 1.8rem;
    line-height: 1.8rem;
    font-weight: 600;
    font-family: "Galano";
    color: #565656;
  }
`;

export const Label = styled.div`
  font-size: 2rem;
  line-height: 3.2rem;
  font-weight: 600;
  font-family: "Galano";
  letter-spacing: 0.44rem;
  color: #565656;
  height: 8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  @media (max-width: 1200px) {
    font-size: 1.6rem;
    color: #cccccc;
  }
`;

export const Icon = styled.div`
  position: relative;
  width: 5rem;
  height: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  @media (max-width: 1200px) {
    flex: 0 0 5rem;
  }
  @media (max-width: 414px) {
    flex: 0 0 3.5rem;
  }
  img {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
`;

export const ProgressBar = styled.div`
  width: 1.2rem;
  height: 100%;
  margin: 0 3.3rem;
  border-radius: 1rem;
  /* padding-top: 3.4rem; */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  @media (max-width: 1200px) {
    margin: 0 2rem;
  }

  .dot {
    width: 12px;
    height: 12px;
    background: #565656 0% 0% no-repeat padding-box;
    border-radius: 50%;
    margin: 0.2rem 0;
  }

  hr {
    width: 0.2rem;
    height: 6.5rem;
    background: #565656;
  }
`;

export const Tooltip = styled.div`
  position: absolute;
  top: -1.3rem;
  left: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;

  & div {
    text-align: center;
    font: normal normal bold 15px/13px "Galano";
    letter-spacing: -0.9px;
    color: #565656;
    margin-left: 0.5rem;
  }

  & img {
    width: 9px;
    height: 10px;
    transform: translateY(0.4rem);
  }
`;

export const StagesDesktop = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  @media (max-width: 1200px) {
    display: none;
  }
`;

export const StagesMobile = styled.div`
  display: none;
  @media (max-width: 1200px) {
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;

export const Close = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;

  & div {
    position: absolute;
    text-align: center;
    font: normal normal bold 15px/13px "Galano";
    letter-spacing: -0.9px;
    color: #565656;
    margin-left: 0.5rem;
  }

  & img {
    position: relative;
    bottom: 20px;
    left: 15px;
    width: 35px;
    height: 35px;
    transform: translateY(0.4rem);
  }
`;

interface PropsModal {
  url: string;
};

export const ModalContainer = styled.div<PropsModal>`
  position: absolute;
  width: max-content;
  height: max-content;
  max-width: 100vw;
  max-height: 100vh;
  z-index: 9999;
  top: 1rem;
  left: -30rem;
  & button {
    visibility: 0;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    z-index: 9999;
  }

  .modal {
    font-family: "Galano";
    position: relative;
    width: 100%;
    max-width: 590px;
    padding: 30px;
    background: #565656;
    color: #fff;
    display: flex;
    justify-content: space-between;
  }
  .modal .video {
    flex: 0 0 45%;
  }
  .modal .video iframe {
    width: 100%;
  }
  .modal .info {
    flex: ${(props) => (props.url ? "0 0 50%" : "")};
  }
  .modal .info .etapa {
    letter-spacing: 3px;
    color: #fff;
  }
  .modal .info .nome {
    margin-bottom: 25px;
    font-weight: bold;
    color: #fff;
    font-size: 18px;
  }

  .modal .info .descricao {
    color: #fff;
    font-size: 14px;
  }
  @media (max-width: 800px) {
    .modal {
      max-width: 400px;
      margin-left: 90px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      top: -2rem;
    }
    .modal .video {
      margin-top: 20px;
    }
  }

  @media (max-width: 400px) {
    .modal {
      max-width: 350px;
      max-height: 500px;
      margin-left: 110px;
    }
  }
`;
